import { gql } from '@apollo/client';

import './Story.scss';
import RichStory from '@justgiving/rich-story';
import { captureException } from '@sentry/browser';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { StoryFragment } from '../../../types/__generated__';
import clientConfig from '../../client/config';
import usePageQuery, {
  UsePageQueryResult,
  buildQuery,
} from '../../hooks/usePageQuery';
import styles from './Story.scss';
import StorySkeleton from './StorySkeleton';

const FRAGMENT = buildQuery(gql`
  fragment Story on Page {
    id
    story
  }
`);

const Story: FunctionComponent = ({ children }) => {
  const result = usePageQuery<StoryFragment>(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });

  if (result.loading) {
    return <StorySkeleton animated displayRefreshButton={false} />;
  }

  if (result.error) {
    captureException(result.error);
    return <StorySkeleton onRefresh={result.refetch} />;
  }

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  if (!result.data.story) {
    return <>{children}</>;
  }

  let story;
  try {
    story = JSON.parse(result.data.story);
  } catch {
    story = result.data.story;
  }

  if (Array.isArray(story) && story[0] && story[0].type) {
    return (
      <div className={styles.story}>
        <RichStory
          imageBaseUri={clientConfig.imageServiceUrl}
          imageTemplate="CrowdfundingStoryImage"
          storyNodes={story}
        />
      </div>
    );
  }
  if (typeof story === 'string') {
    return (
      <div
        data-qa="story-content"
        className={classNames(
          'jg-pages-section__content',
          'jg-space-plmd@xl',
          styles.story,
        )}
        dangerouslySetInnerHTML={{ __html: story }}
      />
    );
  }

  return <>{children}</>;
};

export default Story;
